import { render, staticRenderFns } from "./AddProcess.vue?vue&type=template&id=788723fa&scoped=true"
import script from "./AddProcess.vue?vue&type=script&lang=js"
export * from "./AddProcess.vue?vue&type=script&lang=js"
import style0 from "./AddProcess.vue?vue&type=style&index=0&id=788723fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788723fa",
  null
  
)

export default component.exports